import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { DataError, TableLoading } from "@digital-services/ui";
import { Pagination, useSortQueryString } from "@ds-cps/ui";

import { NoResultsWithIcon } from "@components/from_fota/NoResultsWithIcon";

import { useGetResources } from "@resource/services/use-get-resources";

import { CreateFilterOptions } from "../services/CreateFilterOptions";
import { useResourcesContext } from "./context/useResourcesContext";
import { ResourcesOverviewTable } from "./table/ResourcesOverviewTable";

// TBD reduce complexity here
export const SectionWithResourcesTable = () => {
  const { organizationId } = useParams();

  const { activeSort, sortDirection, handleSort } = useSortQueryString({
    defaultSort: "registered-at"
  });

  const {
    resourceTypeFilter,
    productFamilyNameFilter,
    ownerFilter,
    relationshipFilter,
    searchQuery,
    setSearchHasError
  } = useResourcesContext();

  const created = new CreateFilterOptions({
    resourceTypeFilter,
    productFamilyNameFilter,
    searchQuery
  });

  if (organizationId) {
    created.forTabResources(organizationId, relationshipFilter);
  } else {
    created.forPageResources(ownerFilter);
  }

  const { resources, isLoading, totalCount, hasError } = useGetResources(
    activeSort, // is used to define sortBy value for Backend request
    sortDirection,
    created.filterOptions
  );

  if (searchQuery && hasError) {
    setSearchHasError(true);
  }

  const { t: tResources } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  if (hasError) {
    return (
      <DataError message={tResources("load.error.message")} variant="primary" />
    );
  }

  const noData = !hasError && (!totalCount || totalCount === 0);

  const hidePagination =
    !isLoading && noData && (!searchQuery || searchQuery?.length > 0);

  return (
    <>
      <div data-testid="resources-overview-table">
        {isLoading ? (
          <>
            <TableLoading isDarker />
            <TableLoading isDarker />
          </>
        ) : noData && !searchQuery ? (
          <NoResultsWithIcon message={tResources("load.none.message")} />
        ) : noData && searchQuery?.length > 0 ? (
          <NoResultsWithIcon message={tResources("search.no-search-results")} />
        ) : (
          <ResourcesOverviewTable
            resources={resources ?? []}
            activeSort={activeSort}
            sortDirection={sortDirection}
            handleSort={handleSort}
          />
        )}
      </div>

      {hidePagination ? null : <Pagination totalCount={totalCount!} />}
    </>
  );
};
